define('services/notifications/base-push-notification',[
    'backbone', 
    'underscore',
    'services/firebase.service'
], function (Backbone, _, FirebaseService) {

    var BasePushNotification = Backbone.View.extend({

        handle: function(notification) {
            this.notification = notification;
            if (notification.tap) {
                // Use Capacitor Firebase service for badge (replaces FirebasePlugin.setBadgeNumber)
                FirebaseService.setBadgeNumber(0);
                this.handleTap();
            }
        },
    });

    return BasePushNotification;
});

